import React, { createContext, useContext, useState, useEffect } from 'react';

const DateContext = createContext();

export const useDateContext = () => useContext(DateContext);

export const DateProvider = ({ children }) => {
    const [currentDate, setCurrentDate] = useState({});
    const [currentWeekDates, setCurrentWeekDates] = useState([]);
    const [nextWeekDates, setNextWeekDates] = useState([]);
    const [currentWeekMonday, setCurrentWeekMonday] = useState(null);
    const [nextWeekMonday, setNextWeekMonday] = useState(null);

    useEffect(() => {
        const getCurrentDate = () => {
            const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
            const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
            const today = new Date();
            const dayOfWeek = today.getDay() === 0 ? 6 : today.getDay() - 1; // Adjust day index (0-6) to start from Monday
            const dayOfMonth = today.getDate(); // Get the day of the month (1-31)
            const month = today.getMonth(); // Get the month index (0-11)
            const year = today.getFullYear(); // Get the full year (4 digits)

            return {
                dayOfWeek: days[dayOfWeek],
                dayOfMonth,
                month: months[month],
                year
            };
        };

        const formatDateString = (date) => {
            const year = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const day = date.getDate().toString().padStart(2, '0');
            return `${year}-${month}-${day}`;
        };

        const getCurrentWeekDates = () => {
            const currentDate = new Date();
            const currentDayOfWeek = currentDate.getDay() === 0 ? 6 : currentDate.getDay() - 1; // Adjust day index (0-6) to start from Monday

            // Calculate the date of the Monday of the current week
            const mondayDate = new Date(currentDate);
            mondayDate.setDate(currentDate.getDate() - currentDayOfWeek);

            // Initialize an array to store the dates of the current week
            const weekDates = [];

            // Loop through each day of the week starting from Monday
            for (let i = 0; i < 7; i++) {
                const date = new Date(mondayDate);
                date.setDate(mondayDate.getDate() + i); // Increment the date by the day index
                weekDates.push(formatDateString(date)); // Add the formatted date string to the array
            }

            return {
                weekDates,
                mondayDate
            };
        };

        const getNextWeekDates = () => {
            const currentDate = new Date();
            const currentDayOfWeek = currentDate.getDay() === 0 ? 6 : currentDate.getDay() - 1; // Adjust day index (0-6) to start from Monday

            // Calculate the date of the Monday of the next week
            const nextMondayDate = new Date(currentDate);
            nextMondayDate.setDate(currentDate.getDate() + (7 - currentDayOfWeek));

            // Initialize an array to store the dates of the next week
            const weekDates = [];

            // Loop through each day of the week starting from next Monday
            for (let i = 0; i < 7; i++) {
                const date = new Date(nextMondayDate);
                date.setDate(nextMondayDate.getDate() + i); // Increment the date by the day index
                weekDates.push(formatDateString(date)); // Add the formatted date string to the array
            }

            return {
                weekDates,
                nextMondayDate
            };
        };

        const currentWeek = getCurrentWeekDates();
        const nextWeek = getNextWeekDates();

        setCurrentDate(getCurrentDate());
        setCurrentWeekDates(currentWeek.weekDates);
        setCurrentWeekMonday(currentWeek.mondayDate);
        setNextWeekDates(nextWeek.weekDates);
        setNextWeekMonday(nextWeek.nextMondayDate);
    }, []);

    return (
        <DateContext.Provider value={{ currentDate, currentWeekDates, nextWeekDates, currentWeekMonday, nextWeekMonday }}>
            {children}
        </DateContext.Provider>
    );
};

export default DateContext;